import { DATE_FULL_FORMAT_FROM_TIME } from '../../../../../constants/date'
import { ROLE_TRANSLATION_ALIASES } from '../../../../../constants/user'
import { filterVisibleItems } from '../../../../../utils/common'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../../../Entity'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../../../Formik'
import { formatDate } from '../../../../Table'
import {
  getUserProfileHeaderArchivedAtInfoItem,
  getUserProfileHeaderRegistrationInfoItem,
  getUserRoleSelectStaffOptions,
  hasUserProfileHeaderArchiveData,
  hasUserProfileHeaderRegistrationData,
  USER_EDIT_ROLE_FIELD_NAME,
} from '../../../../User'

import { UserUserProfilePageHeaderStaffInfoItemName } from './useUserProfilePageHeaderStaffInfoItems.constants'

function getUserProfilePageHeaderStaffCanEditRole(staffData) {
  return staffData?.permissions?.can_edit_role
}

function getUserProfilePageHeaderStaffCanEditJobPosition(staffData) {
  return !staffData?.isArchived && staffData?.permissions?.can_edit
}

function getUserProfilePageHeaderStaffCanEditExternalId(staffData) {
  return staffData?.permissions?.can_edit_external_id
}

function getUserProfilePageHeaderStaffCanEditSsoId(staffData) {
  return !staffData?.isArchived && staffData?.permissions?.can_edit_sso_id
}

function getUserProfilePageHeaderStaffCanEditFunctionalRole(staffData) {
  return (
    !staffData?.isArchived && staffData?.permissions?.can_edit_functional_role
  )
}

function getUserProfilePageHeaderStaffShowSsoId(staffData) {
  return staffData?.ssoId !== undefined
}

function getUserProfilePageHeaderStaffShowFunctionalRole(staffData) {
  return staffData?.functionalRole !== undefined
}

function getUserProfilePageHeaderStaffDateValue({ date, locale, timezone }) {
  return date
    ? formatDate({
        date,
        dateFormat: DATE_FULL_FORMAT_FROM_TIME,
        locale,
        timezone,
        useTodayFormat: false,
      })
    : null
}

export function getUserProfilePageHeaderStaffEditRoleInitialValues({
  role,
  t,
}) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
    [USER_EDIT_ROLE_FIELD_NAME]: role
      ? getUserRoleSelectStaffOptions(t).find(item => item.value === role)
      : null,
  }
}

export function getUserProfilePageHeaderStaffInfoItems({
  locale,
  staffData,
  t,
  timezone,
}) {
  const items = [
    {
      canEdit: getUserProfilePageHeaderStaffCanEditRole(staffData),
      isVisible: true,
      name: UserUserProfilePageHeaderStaffInfoItemName.Role,
      title: 'UserProfile.HeaderInfoItemRoleTitleKey',
      value: staffData?.role
        ? t(ROLE_TRANSLATION_ALIASES[staffData.role])
        : null,
    },
    {
      canEdit: getUserProfilePageHeaderStaffCanEditJobPosition(staffData),
      isVisible: true,
      name: UserUserProfilePageHeaderStaffInfoItemName.JobPosition,
      title: 'UserProfile.HeaderInfoItemUserTitleTitleKey',
      titleInfoKey: 'UserProfile.UserTitleTooltipKey',
      value: staffData?.companyPostName,
    },
    {
      canEdit: getUserProfilePageHeaderStaffCanEditFunctionalRole(staffData),
      isVisible: getUserProfilePageHeaderStaffShowFunctionalRole(staffData),
      name: UserUserProfilePageHeaderStaffInfoItemName.FunctionalRole,
      title: 'UserProfile.HeaderInfoItemFunctionalRoleTitleKey',
      value: staffData?.functionalRole?.name ?? null,
    },
    {
      canEdit: getUserProfilePageHeaderStaffCanEditExternalId(staffData),
      isVisible: staffData?.externalId !== undefined,
      name: UserUserProfilePageHeaderStaffInfoItemName.ExternalId,
      title: 'UserProfile.HeaderInfoItemExternalIdTitleKey',
      value: staffData?.externalId,
    },
    {
      canEdit: getUserProfilePageHeaderStaffCanEditSsoId(staffData),
      isVisible: getUserProfilePageHeaderStaffShowSsoId(staffData),
      name: UserUserProfilePageHeaderStaffInfoItemName.SsoId,
      title: 'UserProfile.HeaderInfoItemSsoIdTitleKey',
      value: staffData?.ssoId,
    },
    {
      ...getUserProfileHeaderRegistrationInfoItem({
        locale,
        timezone,
        userData: staffData,
      }),
      isVisible: hasUserProfileHeaderRegistrationData(staffData),
    },
    {
      canEdit: false,
      isVisible: staffData?.lastLoginAt !== undefined,
      name: UserUserProfilePageHeaderStaffInfoItemName.LastLogin,
      title: 'UserProfile.HeaderInfoItemLastLoginTitleKey',
      value: getUserProfilePageHeaderStaffDateValue({
        date: staffData?.lastLoginAt,
        locale,
        timezone,
      }),
    },
    {
      ...getUserProfileHeaderArchivedAtInfoItem({
        locale,
        timezone,
        userData: staffData,
      }),
      isVisible: hasUserProfileHeaderArchiveData(staffData),
    },
  ]

  return filterVisibleItems(items)
}
